customElements.define('fostr-pdp-tabs-bhg', class extends FostrElement {

    constructor() {
        super({ name: 'PDP Tabs: BHG', version: 'v1.0.0' });
    }

    connectedCallback() {
        this.title = this.getTitle();
        this.groups = this.getGroups();
        this.setOutput();
        this.setEventListeners();
    }

    getTitle() {
        let value = this.getAttribute("title");
        return (value) ? value : "";
    }

    getGroups() {
        let groups = [];

        for (let i = 0; i < this.children.length; i++) {
            let el = this.children[i];
            groups[i] = {
                title: el.getAttribute('title'),
                content: el.innerHTML
            };
        }

        return groups;
    }

    getHeadEl() {
        // content head
        let headEl = document.createElement("div");
        headEl.classList.add('fostr-pdp-tabs-bhg__head');

        // right section
        let rightSectionEl = document.createElement("div");
        headEl.append(this.getSwitch());
        headEl.append(rightSectionEl);

        return headEl;
    }

    getSwitch() {
        let switchEl = document.createElement("div");
        switchEl.classList.add('switch');

        let formName = window.handleize(this.title) + "-" + Math.floor(Math.random() * 100);
        // create switch elements

        for (let i = 0; i < this.groups.length; i++) {
            let group = this.groups[i];
            let labelEl = document.createElement('label');
            let id = Date.now() + "-" + Math.floor(Math.random() * 100) + "-" + group.title.length; // unique id
            labelEl.setAttribute("for", id);
            labelEl.setAttribute("aria-label", group.title);
            labelEl.innerText =  group.title;
            let radioEl = document.createElement('input');
            radioEl.setAttribute("type", "radio");
            radioEl.setAttribute("id", id);
            radioEl.setAttribute("value", group.title);
            radioEl.setAttribute("name", formName);

            // select first item
            if (i === 0) radioEl.setAttribute("checked", "checked");

            switchEl.append(radioEl);
            switchEl.append(labelEl);
        }

        return switchEl;
    }

    getBody() {
        // content body
        let bodyEl = document.createElement("div");
        bodyEl.classList.add('fostr-pdp-tabs-bhg__body');

        // create switch elements
        for (let i = 0; i < this.groups.length; i++) {
            let group = this.groups[i];
            let groupContentEl = document.createElement('div');
            groupContentEl.classList.add("fostr-pdp-tabs-bhg__group","rte");
            groupContentEl.innerHTML = group.content;

            // select first item
            if (i === 0) groupContentEl.classList.add("active");

            bodyEl.append(groupContentEl);
        }

        return bodyEl;
    }

    setOutput() {
        this.classList.add('fostr-pdp-tabs-bhg');

        // container
        let containerEl = document.createElement("div");
        containerEl.append(this.getHeadEl());
        containerEl.append(this.getBody());

        this.innerHTML = containerEl.innerHTML;
    }

    setEventListeners() {
        let radioEls = this.querySelectorAll('input[type="radio"]');

        for (let i = 0; i < radioEls.length; i++) {
            let radioEl = radioEls[i];
            radioEl.addEventListener('change', this.updateView.bind(this, i));
        }
    }

    updateView(index) {
        // get current selected option
        let activeContentGroup = this.querySelector('.active');
        if (!activeContentGroup) return

        activeContentGroup.classList.remove('active');
        let newActiveContentGroup = this.querySelectorAll('.fostr-pdp-tabs-bhg__group')[index];

        if (!newActiveContentGroup) return;

        newActiveContentGroup.classList.add('active');
    }
})
